import React from 'react';

interface CustomShowFormValueOnlyProps {
  inputValue: string;
}

const CustomShowFormValueOnly = ({
  inputValue,
}: CustomShowFormValueOnlyProps) => {
  return <span className="show-form-value-only">{inputValue}</span>;
};

export default CustomShowFormValueOnly;
